import * as types from './actionTypes';
import { Module } from 'data/terra/Module';

export interface ModuleState {
  modules: Module[];
  selectedModule?: Module;
}

const initialState: ModuleState = {
  modules: [],
};

export default function reduce(
  state: ModuleState = initialState,
  action: types.ModuleAction
): ModuleState {
  switch (action.type) {
    case types.FETCH_MODULES: {
      return {
        ...state,
        modules: action.modules,
      };
    }
    case types.SELECT_MODULE: {
      return {
        ...state,
        selectedModule: action.module,
      };
    }
    default:
      return state;
  }
}
